// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CircleIcon_wrapper__39ggM","icon":"CircleIcon_icon__2_09Q"};